import { APIError } from "../core/errors";
import {
  getApi,
  postApi,
  getApiErrorAdmin,
  postApiErrorAdmin,
  getApiErrorMypage,
  postApiErrorMypage,
} from "../utils/common";

//管理画面-学生検索結果取得
export const GetStudentList = async (searchCondition) => {
  const urlPath = "/api/admin/student/list/?";
  const searchParams = new URLSearchParams(searchCondition);
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};
//管理画面-未承認件数取得
export const GetUnapplovalCount = async () => {
  const urlPath = "/api/admin/student/unapploval/count/?";
  try {
    const json = await getApi(urlPath);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath);
  }
};
//学生新規登録
export const postAddStudent = async (data) => {
  const urlPath = "/api/admin/student/add/?";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};
//学生情報更新
export const postUpdateStudent = async (user_id, data) => {
  const urlPath = "/api/admin/student/update/?";
  const postData = { user_id: user_id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

//学生承認（更新+メール送信）
export const postApprovalStudent = async (user_id, data) => {
  const urlPath = "/api/admin/student/approval/?";
  const postData = { user_id: user_id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 学生重複チェック
export const getDuplicateStudentList = async (user_id) => {
  const urlPath = "/api/admin/student/duplicate/?";
  const searchParams = new URLSearchParams({
    user_id: user_id,
  });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

//管理画面-学生詳細取得
export const GetStudentDetail = async (userId, isEdit = true) => {
  const urlPath = "/api/admin/student/detail/?";
  const searchParams = new URLSearchParams({
    user_id: userId,
    is_edit: isEdit,
  });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

//管理画面-学生参加講座検索
export const GetApplicantCourseList = async (
  user_id,
  searchCondition,
  offsetNum,
  siteId
) => {
  const urlPath = "/api/admin/student/applicantCourse/list/?";
  const searchParams = new URLSearchParams({
    user_id: user_id,
    ...searchCondition,
    offset_num: offsetNum,
    site_id: siteId,
  });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

//管理画面-学生講座申込情報更新
export const postUpdateApplicantCourse = async (user_id, data) => {
  const urlPath = "/api/admin/student/applicantCourse/update/?";
  const postData = { user_id: user_id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 管理画面-学生情報csvアップロード
export const postUploadStudent = async (data) => {
  const urlPath = "/api/admin/student/upload/";
  const postData = data;
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// マイページ-ユーザー情報取得
export const getMypageUser = async () => {
  const urlPath = "/api/mypage/user/";
  try {
    const json = await getApi(urlPath);
    if (Object.keys(json).length < 1) {
      throw new APIError("API Error", { status: 404 });
    }
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath);
  }
};

// マイページ-ユーザー情報変更
export const postUpdateUserContacts = async (data) => {
  const urlPath = "/api/mypage/user/contacts/update";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorMypage(e, urlPath, postData);
  }
};

// マイページ-ユーザーパスワード変更
export const postUpdateUserPassword = async (data) => {
  const urlPath = "/api/mypage/user/password/update";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorMypage(e, urlPath, postData);
  }
};

// マイページ-入学申込
export const postAdmission = async (data) => {
  const urlPath = "/api/mypage/admission/";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorMypage(e, urlPath, postData);
  }
};

//入力したログインIDが既に他のユーザーに使用されているか確認
export const GetLoginIdIsExist = async (searchCondition) => {
  const urlPath = "/api/admin/student/loginid/exist/?";
  const searchParams = new URLSearchParams(searchCondition);
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};
